import styled from 'styled-components';

const ExclusiveBenefitsStyle = styled.section`
	--fixedWidth: var(--sp99x);
	--wrapperBorderRadius: var(--sp3x);
	--wrapperPadTB: var(--sp1x);
	--wrapperPadLR: var(--sp1x);
	--closeSVGSize: var(--sp2-5x);
	--closeSVGTop: var(--sp3-5x);
	--closeSVGRight: var(--sp4x);
	--topGap: var(--sp4x);
	--contentGap: var(--sp3x);
	--contentTopGap: var(--sp1-5x);
	--contentBottomGap: var(--sp2-5x);
	--imageWidth: var(--sp25x);
	--imageHeight: var(--sp24x);
	--imageBorderRadius: var(--sp2x);
	--contentMaxWidth: 95%;

	position: fixed;
	right: var(--burgerMenuPaddingBottom);
	bottom: var(--burgerMenuPaddingBottom);
	width: var(--fixedWidth);
	isolation: isolate;
	overflow: hidden;
	transform: translateY(120%);
	will-change: transform;
	transition: transform 0.4s 0.3s ease-out;
	z-index: 99999;

	&.is-first {
		transform: translateY(0);
	}

	.exclusive-benefits-inner-wrapper {
		position: relative;
		width: 100%;
		border-radius: var(--wrapperBorderRadius);
		background-color: var(--mainColor);
		padding: var(--wrapperPadTB) var(--wrapperPadLR);
		overflow: hidden;

		&:before {
			content: '';
			position: absolute;
			top: -10%;
			left: -10%;
			width: 120%;
			height: 120%;
			background-color: var(--mainColor);
			z-index: -1;
		}
	}

	.exclusive-benefits-inner-wrapper-content {
		display: flex;
		gap: var(--contentGap);
		align-items: stretch;
	}

	.content-top-wrapper {
		display: flex;
		flex-direction: column;
		gap: var(--contentTopGap);
	}

	.image-wrapper {
		width: var(--imageWidth);
		height: var(--imageHeight);
		border-radius: var(--imageBorderRadius);
		overflow: hidden;
		position: relative;
		background-color: #e9e9e9;

		.image-cont {
			--proportion: 0;

			display: flex;
			height: 100%;

			img {
				object-fit: contain;
				object-position: right bottom;
			}
		}
	}

	.content-wrapper {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		gap: var(--contentBottomGap);
	}

	.exclusive-benefits-title {
		max-width: calc(100% - var(--closeSVGSize) - var(--topGap) - (var(--closeSVGRight) - var(--wrapperPadLR)));
	}

	.exclusive-benefits-title {
		color: var(--neutral900);
	}

	.amount-accent {
		color: var(--pink1000);
		font-weight: 500;
	}

	.svg-block {
		position: absolute;
		top: var(--closeSVGTop);
		right: var(--closeSVGRight);
		flex-shrink: 0;
		display: flex;
		max-width: var(--closeSVGSize);
		width: 100%;
		height: fit-content;
		cursor: pointer;
	}

	svg {
		height: var(--closeSVGSize);

		path {
			transition: fill var(--trTime) ease-out;
		}

		@media (pointer: fine) {
			@media (hover: hover) {
				&:hover {
					path {
						fill: var(--neutral1000);
					}
				}
			}
		}
	}

	.app-icon {
		color: var(--neutral1000);
	}

	.exclusive-benefits-description {
		color: var(--neutral1000);
		max-width: var(--contentMaxWidth);
	}

	&.hide {
		display: none;
		pointer-events: none;
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--fixedWidth: var(--sp99x);
		--wrapperBorderRadius: var(--sp3x);
		--wrapperPadTB: var(--sp1x);
		--wrapperPadLR: var(--sp1x);
		--closeSVGSize: var(--sp2-5x);
		--closeSVGTop: var(--sp3-5x);
		--closeSVGRight: var(--sp3-5x);
		--topGap: var(--sp4x);
		--contentGap: var(--sp3x);
		--contentTopGap: var(--sp1-5x);
		--contentBottomGap: var(--sp2-5x);
		--imageWidth: var(--sp25x);
		--imageHeight: var(--sp24x);
		--imageBorderRadius: var(--sp2x);
		--contentMaxWidth: 85%;
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--fixedWidth: var(--sp81x);
		--wrapperBorderRadius: var(--sp2x);
		--wrapperPadTB: var(--sp1x);
		--wrapperPadLR: var(--sp1x);
		--closeSVGSize: 14px;
		--closeSVGTop: var(--sp2x);
		--closeSVGRight: var(--sp2x);
		--topGap: var(--sp4x);
		--contentGap: var(--sp1-5x);
		--contentTopGap: var(--sp1x);
		--contentBottomGap: var(--sp2x);
		--imageWidth: var(--sp18x);
		--imageHeight: var(--sp18x);
		--imageBorderRadius: var(--sp1-5x);
		--contentMaxWidth: 75%;
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--fixedWidth: var(--sp71x);
		--wrapperBorderRadius: var(--sp1-5x);
		--wrapperPadTB: var(--sp1x);
		--wrapperPadLR: var(--sp1x);
		--closeSVGSize: 14px;
		--closeSVGTop: var(--sp2-5x);
		--closeSVGRight: var(--sp2-5x);
		--topGap: var(--sp4x);
		--contentGap: var(--sp1-5x);
		--contentTopGap: var(--sp1x);
		--contentBottomGap: var(--sp1-5x);
		--imageWidth: var(--sp18x);
		--imageHeight: var(--sp18x);
		--imageBorderRadius: var(--sp1-5x);
		--contentMaxWidth: 90%;
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--fixedWidth: var(--sp67x);
		--wrapperBorderRadius: var(--sp1-5x);
		--wrapperPadTB: var(--sp1x);
		--wrapperPadLR: var(--sp1x);
		--closeSVGSize: 14px;
		--closeSVGTop: var(--sp2x);
		--closeSVGRight: var(--sp2x);
		--topGap: var(--sp4x);
		--contentGap: var(--sp1-5x);
		--contentTopGap: var(--sp1x);
		--contentBottomGap: var(--sp2x);
		--imageWidth: var(--sp17x);
		--imageHeight: var(--sp17x);
		--imageBorderRadius: var(--sp1-5x);
		--contentMaxWidth: 90%;
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--fixedWidth: var(--sp63x);
		--wrapperBorderRadius: var(--sp1-5x);
		--wrapperPadTB: var(--sp1x);
		--wrapperPadLR: var(--sp1x);
		--closeSVGSize: 14px;
		--closeSVGTop: var(--sp1-5x);
		--closeSVGRight: var(--sp1-5x);
		--topGap: var(--sp4x);
		--contentGap: var(--sp1x);
		--contentTopGap: var(--sp1x);
		--contentBottomGap: var(--sp2x);
		--imageWidth: var(--sp16x);
		--imageHeight: var(--sp16x);
		--imageBorderRadius: var(--sp1-5x);
		--contentMaxWidth: calc(100% - var(--sp2x));
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--fixedWidth: calc(100% - var(--sp4x));
		--wrapperBorderRadius: var(--sp1-5x);
		--wrapperPadTB: var(--sp1-5x);
		--wrapperPadLR: var(--sp1-5x);
		--closeSVGSize: var(--sp1-5x);
		--closeSVGTop: var(--sp1-5x);
		--closeSVGRight: var(--sp1-5x);
		--topGap: var(--sp3x);
		--contentGap: var(--sp1x);
		--contentTopGap: var(--sp0-5x);
		--contentBottomGap: var(--sp1x);
		--imageWidth: var(--sp11x);
		--imageHeight: var(--sp11x);
		--imageBorderRadius: var(--sp1x);
		--contentMaxWidth: 100%;

		.application-button-wrapper {
			margin-top: var(--sp1x);

			.application-button-item {
				width: calc(50% - var(--sp0-5x));

				.app-block {
					justify-content: center;
				}
			}
		}
	}
`;

export default ExclusiveBenefitsStyle;
